import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

let todaysDate = new Date();

root.render(
  <React.StrictMode>
    <div className="page">
      <header className="hero">
        <p className="eyebrow">Doomsday Calculator</p>
        <h1>Learn the Doomsday Rule</h1>
        <p className="subtitle">
          The{" "}
          <a
            href="https://en.wikipedia.org/wiki/Doomsday_rule"
            target="_blank"
            rel="noreferrer"
          >
            Doomsday Rule
          </a>{" "}
          is an algorithm created by John Conway for calculating the day of the
          week of any date.
        </p>
      </header>
      <main>
        <App todaysDate={todaysDate} />
      </main>
      <footer className="site-footer">
        <a href="https://www.oweng.co.uk" target="_blank" rel="noreferrer">
          <img
            src="/owenface-3.png"
            alt="Owen G logo"
          />
        </a>
        <p>
          Created by{" "}
          <a href="https://www.oweng.co.uk" target="_blank" rel="noreferrer">
            Owen G
          </a>
        </p>
      </footer>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
